const fetchValue = async (vrsServices, offer) => {
  const vrsResponse = await vrsServices.getDetailsById(offer.vehicleId);
  if (!vrsResponse) {
    return offer;
  }
  return {
    ...offer,
    year: vrsResponse.yearId,
    make: vrsResponse.makeName,
    model: vrsResponse.modelName,
    trim: vrsResponse.trimName
  };
};
const getVrsReferenceData = async _ref => {
  let {
    vrsServices,
    offers
  } = _ref;
  if (!vrsServices || !offers || offers.length === 0) {
    return [];
  }
  offers = await Promise.all(offers.map(async offer => fetchValue(vrsServices, offer)));
  // Sort by createdDate just in case offers get out of order when adding vrs data
  offers.sort((offer1, offer2) => Date.parse(offer2.createdDate) - Date.parse(offer1.createdDate));
  return offers;
};
export { getVrsReferenceData as default };
